export default function Urgency() {
  return (
    <section className="py-20 md:py-28 bg-[#FFF8E1] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle, #1A2B4A 1px, transparent 1px)`,
          backgroundSize: '30px 30px',
        }}></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-8 md:px-16 text-center">
        {/* Limited Badge */}
        <div className="inline-block mb-6">
          <div className="bg-red-600 text-white text-sm font-bold px-6 py-2 rounded-full uppercase tracking-wider">
            限定募集
          </div>
        </div>

        {/* Heading */}
        <h2 className="text-4xl md:text-5xl font-black text-[#1A2B4A] leading-tight mb-8 font-serif">
          3月の需要爆発を前に、急遽"仕入れ枠"を解放する理由。
        </h2>

        {/* Content */}
        <div className="space-y-6 text-lg text-gray-700 leading-relaxed mb-12 font-serif">
          <p>
            市場には、車を必要としているお客様が溢れています。しかし、事業拡大のスピードに対して、車両を仕入れるための<span className="text-red-600 font-bold text-xl">「前受資金(アセット枠)」が不足</span>しているのが現状です。
          </p>
          <p>
            そこで今回、これまでクローズドにご案内していた投資枠を、WEBセミナー参加者限定で特別に解放することに決定いたしました。
          </p>
          <p className="text-xl font-bold text-[#1A2B4A] bg-white p-6 rounded-xl border-2 border-[#D4AF37] shadow-lg">
            ※今回は事業拡大のための<span className="text-red-600">"限定枠のご案内"</span>です。
          </p>
        </div>

        {/* Limited Slots Notice */}
        <div className="mb-8">
          <div className="inline-block bg-red-600 text-white text-2xl font-black px-8 py-4 rounded-xl shadow-lg font-serif">
            限定10枠
          </div>
        </div>

        {/* Seminar Schedule */}
        <div className="mb-12 bg-white p-8 rounded-xl border-2 border-[#D4AF37] shadow-lg">
          <h3 className="text-2xl font-black text-[#1A2B4A] mb-6 font-serif">セミナー日程</h3>
          <div className="space-y-4 text-lg text-gray-700 font-serif">
            <p className="font-bold line-through">1月29日20時～（締め切り16時）</p>
            <p className="font-bold">1月30日20時～（締め切り16時）</p>
            <p className="font-bold">両日18時にzoomリンクをメールで送ります</p>
          </div>
        </div>

        {/* CTA Button with Animation */}
        <div className="relative inline-block w-full md:w-auto max-w-[90%] md:max-w-none mx-auto">
          {/* Pulsing Ring Animation */}
          <div className="absolute inset-0 animate-ping">
            <div className="w-full h-full border-4 border-[#D4AF37] rounded-full opacity-75"></div>
          </div>

          <a 
            href="https://forms.gle/vdJZoFV3tEuxApQD7"
            target="_blank"
            rel="noopener noreferrer"
            className="relative group bg-gradient-to-r from-red-600 to-red-700 text-white font-bold text-xs md:text-lg px-6 md:px-14 py-4 md:py-6 rounded-full inline-flex items-center gap-2 md:gap-4 hover:shadow-2xl hover:shadow-red-600/50 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer font-serif w-full md:w-auto justify-center"
          >
            【WEBセミナーで詳細を確認する】
            <div className="w-7 h-7 md:w-10 md:h-10 flex items-center justify-center bg-white rounded-full group-hover:translate-x-1 transition-transform duration-300 flex-shrink-0">
              <i className="ri-arrow-right-line text-red-600 text-base md:text-xl"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
